import { UserProfileContext } from '../User.contexts'

function UserProfileContextProvider({ children, ...restProps }) {
  return <UserProfileContext value={restProps}>{children}</UserProfileContext>
}

export default UserProfileContextProvider
